/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanApiResponse } from '../../models/boolean-api-response';
import { CheckAccessCommand } from '../../models/check-access-command';

export interface CheckAdminOrMasterAccessAsync$Params {
  command?: CheckAccessCommand;
}

export function checkAdminOrMasterAccessAsync(http: HttpClient, rootUrl: string, params?: CheckAdminOrMasterAccessAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkAdminOrMasterAccessAsync.PATH, 'get');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanApiResponse>;
    })
  );
}

checkAdminOrMasterAccessAsync.PATH = '/api/access/admin-master';
